import { Ref, ref } from "vue";

interface UseSelectedPositionMarker {
  selectedPositionMarker: Ref<any>;
  createSelectedPositionMarker: (
    map: any,
    latitude?: number,
    longitude?: number,
    infoWindowContent?: string
  ) => void;
  removeSelectedPositionMarker: () => void;
  updateSelectedPositionMarker: (lat: number, lng: number) => void;
  getSelectedPositionMarkerCoord: () => any;
}

export const useSelectedPositionMarker = (
  createMarker: (
    lat: number,
    lng: number,
    markerImage: () => any,
    zIndex: number
  ) => any,
  createInfoWindow: (marker: any, infoWindowContent: string) => void
): UseSelectedPositionMarker => {
  const selectedPositionMarker = ref<any>();

  const getSelectedPositionMarkerImage = () => {
    return {
      url: require("@/assets/icons/marker_selected.svg"),
      size: new window.naver.maps.Size(20, 32),
      origin: new window.naver.maps.Point(0, 0),
      anchor: new window.naver.maps.Point(10, 16),
    };
  };

  const createSelectedPositionMarker = (
    map: any,
    latitude?: number,
    longitude?: number,
    infoWindowContent?: string
  ) => {
    if (!latitude || !longitude) return;

    selectedPositionMarker.value = createMarker(
      latitude,
      longitude,
      getSelectedPositionMarkerImage,
      200
    );
    selectedPositionMarker.value.setMap(map);

    if (infoWindowContent?.length) {
      createInfoWindow(selectedPositionMarker.value, infoWindowContent);
    }
  };

  const removeSelectedPositionMarker = () => {
    selectedPositionMarker.value?.setMap(null);
  };

  const updateSelectedPositionMarker = (lat: number, lng: number) => {
    const position = new window.naver.maps.LatLng(lat, lng);
    selectedPositionMarker.value.setPosition(position);
  };

  const getSelectedPositionMarkerCoord = () => {
    return selectedPositionMarker.value.getPosition();
  };

  return {
    selectedPositionMarker,
    createSelectedPositionMarker,
    removeSelectedPositionMarker,
    updateSelectedPositionMarker,
    getSelectedPositionMarkerCoord,
  };
};
